import React, { useState, useEffect, useRef } from 'react';
import { get } from '../../../services/apiController';
import { DEBOUNCE_DELAY } from '../../../util/constant';
import { Table, Form } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useDebounce from '../../useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import Breadcrumb from '../../../components/Breadcrumb';

const DateWiseReport = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [requirementList, setRequirementList] = useState([]);
  const [festivalList, setFestivalList] = useState([]);
  const clickToDownload = useRef(null);

  const [state, setState] = useState({
    companyId: '',
    locationType: '',
    locationId: '',
    festivalId: '',
    festivalDateId: '',
    productId: '',
  });

  function getRequirements(action) {
    try {
      if (state.festivalId) {
        let url = `/fest/requirements/report/date-wise/?festivalId=${state.festivalId}`;
        if (action === 'download') {
          url += `&action=${action}`;
        }
        get(url).then((response) => {
          if (action === 'download') {
            clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
            setTimeout(() => {
              clickToDownload.current.click();
            }, 500);
          } else {
            setRequirementList(response?.data);
            setTotalRecords(response?.data.data.length);
          }
        });
      }
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      getRequirements();
    },
    [],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getFestivals();
  }, []);

  useEffect(() => {
    if (state.festivalId) {
      getRequirements();
    } else {
      setRequirementList([]);
      setTotalRecords(0);
    }
  }, [state]);

  const getFestivals = () => {
    try {
      get(`/fest/festival`).then((response) => {
        setFestivalList(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  };

  return (
    <>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Festival' },
          { link: '#', title: 'Report' },
          { link: '#', title: 'Festival Wise Consolidated' },
        ]}
      />
      <div className="card custom_card">
        <div className=" card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Report - Festival Wise Consolidated
          </h4>
          <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          <div className="card-header-actions">
            <Form.Select
              style={{ width: '200px', marginRight: '20px' }}
              required
              name="festivalId"
              value={state.festivalId}
              onChange={(e) => {
                setState({ ...state, festivalId: e.target.value, festivalDateId: '' });
                setRequirementList([]);
              }}
              aria-label="Floating label select example"
              className="form-select"
            >
              <option value="">Select Festival</option>
              {festivalList.map((item, index) => (
                <option key={index} value={item?.id}>
                  {item?.name} - {item?.year}
                </option>
              ))}
            </Form.Select>
            <GrDocumentExcel
              title="Download Report"
              className="react-icons green"
              style={{ width: '30px', height: '30px', cursor: 'pointer' }}
              onClick={() => getRequirements('download')}
            />
          </div>
        </div>

        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <div className="custom-fest-responsive-table" role="region" aria-labelledby="caption" tabindex="0">
                <Table bordered striped className="text-center">
                  <thead>
                    <tr>
                      {requirementList?.header?.map((headerItem) => {
                        return headerItem != null ? (
                          <th colSpan={headerItem?.span} style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                            {headerItem?.value}
                          </th>
                        ) : (
                          ''
                        );
                      })}
                    </tr>
                    <tr>
                      {requirementList?.subHeader?.map((headerItem) => {
                        return <th style={{ whiteSpace: 'nowrap' }}>{headerItem.value}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {requirementList?.data?.map((item, index) => {
                      return (
                        <tr key={index}>
                          {item?.map((i) => {
                            const backgroundColorStyle = i?.color ? { color: i.color, whiteSpace: 'nowrap' } : { whiteSpace: 'nowrap' };
                            const total = i?.fontWeight && index === totalRecords - 1 ? { fontWeight: i.fontWeight } : {};
                            return <td style={{ ...backgroundColorStyle, ...total }}>{i?.value}</td>;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DateWiseReport;
